export default __webpack_public_path__ + "static/media/noprofile.c3f94521.png";